import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Page from '../../page';
import FormFragment from './Fragment';
import deepMerge from '../../utils/deepMerge';
/**
 * A form page used to manage data
 * @extends {React.Component<import('./types').FormPageProps>}
 */

var FormPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormPage, _React$Component);

  function FormPage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormPage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderSidebar = function (formData, renderFooter) {
      return React.createElement(React.Fragment, null, _this.props.renderSidebar(formData), React.createElement("div", {
        style: {
          marginBottom: 8 * 2
        }
      }), renderFooter(formData));
    };

    _this.renderPage = function (formData, renderContent, renderFooter) {
      var pageProps = _this.props.pageProps;
      var props = deepMerge({
        sidebar: {
          variant: 'property',
          position: 'right',
          children: _this.renderSidebar(formData, renderFooter)
        }
      }, pageProps);
      return React.createElement(Page.Common, props, renderContent(formData));
    };

    _this.renderError = function (errorProps) {
      return React.createElement(FormPageDataItemError, errorProps);
    };

    return _this;
  }

  _createClass(FormPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          renderSidebar = _this$props.renderSidebar,
          rest = _objectWithoutProperties(_this$props, ["renderSidebar"]);

      return React.createElement(FormFragment, Object.assign({
        submitAlign: "left",
        style: {
          padding: 0
        }
      }, rest, {
        renderer: this.renderPage,
        renderError: this.renderError
      }));
    }
  }]);

  return FormPage;
}(React.Component);
/**
 * @param {import('./types').FormPageDataItemErrorProps} props
 */


var FormPageDataItemError = function FormPageDataItemError(_ref) {
  var error = _ref.error,
      dataTypeLabel = _ref.dataTypeLabel;
  var label = dataTypeLabel;
  if (!label) label = "Item";
  if (error.status === 404) return React.createElement(Page.NotFound, {
    hideNavBar: true,
    title: "".concat(error.status, " - ").concat(label, " was not found"),
    message: error.text
  });else return React.createElement(Page.Error, {
    hideNavBar: true,
    message: "".concat(error.status, " - ").concat(error.text)
  });
};

FormPage.defaultProps = {
  variant: 'filled'
};
export default FormPage;